import React from 'react'
import { useSelector } from 'react-redux'
import { getEnhancedBetslipSetting } from '@core/Areas/Settings/Store/selectors'
import { SmartBetslipToast } from './Components/MultiToast/Components/SmartBetslipToast'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'

export const SmartBetSlipMultiToastLegacy: React.FC<object> = React.memo(() => {
  const isSmartBetslipSettingActive = useSelector(getEnhancedBetslipSetting)
  const isNewBetSlipFeatureActive = useFeature(FeatureFlags.NEW_BET_SLIP_DESIGN.key)

  if (isNewBetSlipFeatureActive || !isSmartBetslipSettingActive) {
    return null
  }
  return <SmartBetslipToast />
})
